// src/pages/Auth/Aanmelden.js
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Haal wél deze helpers uit je eigen firebase.js
import {
  auth,
  googleProvider,
  sendSignInLinkToEmail,
  signInWithEmailLink,
  signInWithPopup
} from "../../firebase";

// Haal deze alleen uit de SDK zelf (niet uit ../../firebase)
import { isSignInWithEmailLink } from "firebase/auth";

import "./Aanmelden.css"; // Exact dezelfde CSS als in inloggen.css

function Aanmelden() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  // Zelfde email-link callback als in Inloggen
  useEffect(() => {
    if (isSignInWithEmailLink(auth, window.location.href)) {
      let storedEmail = window.localStorage.getItem("emailForSignIn");
      if (!storedEmail) {
        storedEmail = window.prompt("Vul je e-mail in om verder te gaan");
      }
      signInWithEmailLink(auth, storedEmail, window.location.href)
        .then((result) => {
          window.localStorage.removeItem("emailForSignIn");
          setMessage("Je bent ingelogd! Je wordt doorgestuurd…");
          setTimeout(() => navigate("/account"), 1500);
        })
        .catch((err) => {
          console.error(err);
          setMessage("Er is iets misgegaan bij registreren.");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleSubmitEmailLink = async (e) => {
    e.preventDefault();
    if (!email) return;

    try {
      // Met dezelfde settings: na klikken terug naar /Aanmelden
      const actionCodeSettings = {
        url: window.location.origin + "/Aanmelden",
        handleCodeInApp: true,
      };
      await sendSignInLinkToEmail(auth, email, actionCodeSettings);
      window.localStorage.setItem("emailForSignIn", email);
      setMessage(
        "Er is een registratie-link verstuurd naar je e-mail. Check je inbox!"
      );
      setEmail("");
    } catch (error) {
      console.error(error);
      setMessage("Kon geen registratielink versturen. Probeer later opnieuw.");
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      await signInWithPopup(auth, googleProvider);
      setMessage("Registratie/Inloggen succesvol! Je wordt doorgestuurd…");
      setTimeout(() => navigate("/account"), 1200);
    } catch (error) {
      console.error(error);
      setMessage("Google registratie is mislukt.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Aanmelden</h2>

      {/* E-mail registratie-link */}
      <form onSubmit={handleSubmitEmailLink} className="auth-form">
        <input
          type="email"
          placeholder="Vul je e-mail in"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Verstuur registratielink</button>
      </form>

      <div className="or-divider">of</div>

      {/* Google registratie */}
      <button className="google-btn" onClick={handleGoogleSignIn}>
        Aanmelden met Google
      </button>

      {message && <div className="auth-message">{message}</div>}
    </div>
  );
}

export default Aanmelden;
